import {
  QUOTE_REQUEST,
  QUOTE_SUCCESS,
  QUOTE_FAILURE,

  SELECT_PRICE_REQUEST,
  SELECT_PRICE_SUCCESS,
  SELECT_PRICE_FAILURE,

  LOAD_QUOTE_REQUEST,
  LOAD_QUOTE_SUCCESS,
  LOAD_QUOTE_FAILURE,

  EMAIL_QUOTE_REQUEST,
  EMAIL_QUOTE_SUCCESS,
  EMAIL_QUOTE_FAILURE,
} from 'pu-redux/actions/QuoteActions';

const loading = (state = false, action) => {
  switch (action.type) {
    case QUOTE_REQUEST:
    case SELECT_PRICE_REQUEST:
    case LOAD_QUOTE_REQUEST:
    case EMAIL_QUOTE_REQUEST:
      return true;
    case QUOTE_SUCCESS:
    case QUOTE_FAILURE:
    case SELECT_PRICE_SUCCESS:
    case SELECT_PRICE_FAILURE:
    case LOAD_QUOTE_SUCCESS:
    case LOAD_QUOTE_FAILURE:
    case EMAIL_QUOTE_SUCCESS:
    case EMAIL_QUOTE_FAILURE:
      return false;
    default:
      return state;
  }
};

export default loading;
